import axios from "axios";
import Config from "../../config";

const ReportOverView = params => {
    const {channel_id, source, start_date, end_date} = params
    return axios({
        method: "POST",
        url: (Config.url || '') + "/api/report/over-view",
        data: { channel_id, source, start_date, end_date }
    });
};

export default ReportOverView;
